// extracted by mini-css-extract-plugin
export default {"stop-word":"StopWord_stop-word__LR7es","active":"StopWord_active__7F5Yu"};